// Chart.jsはCDNから読み込むため、importは削除
// import Chart from 'chart.js/auto'

document.addEventListener('turbolinks:load', () => {
  // 既存のチャートを破棄
  if (window.mankuuCharts) {
    window.mankuuCharts.forEach(chart => chart.destroy());
  }
  window.mankuuCharts = [];
  // メイングラフ
  if (document.getElementById('company-mankuu') != null) {
    const context = document.getElementById('company-mankuu').getContext('2d');
    const displayType = context.canvas.dataset.displayType || 'daily';
    
    let chartType = 'bar';
    let label = '駐車台数';
    
    switch(displayType) {
      case 'weekly':
        label = '最大駐車台数';
        break;
      case 'hourly':
        label = '平均駐車台数';
        chartType = 'line';
        break;
      case 'cabin':
        label = '稼働率(%)';
        break;
    }
    
    const countNewGraph = new Chart(context, {
      type: chartType,
      data: {
        labels: JSON.parse(context.canvas.dataset.labels),
        datasets: [
          {
            label: label,
            backgroundColor: chartType === 'line' ? "rgba(12, 201, 167, 0.2)" : "#0CC9A7",
            borderColor: "#0CC9A7",
            hoverBackgroundColor: "#0AA995",
            data: JSON.parse(context.canvas.dataset.mankuuData),
            fill: chartType === 'line',
            tension: 0.1
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return displayType === 'cabin' ? value + '%' : value;
              }
            }
          }
        }
      }
    });
    window.mankuuCharts.push(countNewGraph);
  }
  
  // 入出庫分布グラフ
  if (document.getElementById('in-out-distribution') != null) {
    const context = document.getElementById('in-out-distribution').getContext('2d');
    
    console.log('In-out distribution canvas found');
    console.log('Labels:', context.canvas.dataset.labels);
    console.log('In data:', context.canvas.dataset.inData);
    console.log('Out data:', context.canvas.dataset.outData);
    
    try {
      const labels = JSON.parse(context.canvas.dataset.labels);
      const inData = JSON.parse(context.canvas.dataset.inData);
      const outData = JSON.parse(context.canvas.dataset.outData);
      
      console.log('Parsed data:', { labels, inData, outData });
      
      const distributionGraph = new Chart(context, {
        type: 'line',
        data: {
          labels: labels.map(h => `${h}時`),
          datasets: [
            {
              label: '入庫台数',
              backgroundColor: "rgba(12, 201, 167, 0.2)",
              borderColor: "#0CC9A7",
              data: inData,
              fill: true,
              tension: 0.1
            },
            {
              label: '出庫台数',
              backgroundColor: "rgba(255, 127, 80, 0.2)",
              borderColor: "rgb(255, 127, 80)",
              data: outData,
              fill: true,
              tension: 0.1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          }
        }
      });
      window.mankuuCharts.push(distributionGraph);
    } catch (e) {
      console.error('Error creating in-out distribution chart:', e);
    }
  }
  
  // 駐車時間分布グラフ
  if (document.getElementById('duration-distribution') != null) {
    const context = document.getElementById('duration-distribution').getContext('2d');
    
    console.log('Duration distribution canvas found');
    console.log('Labels:', context.canvas.dataset.labels);
    console.log('Duration data:', context.canvas.dataset.durationData);
    
    try {
      const labels = JSON.parse(context.canvas.dataset.labels);
      const durationData = JSON.parse(context.canvas.dataset.durationData);
      
      console.log('Parsed duration data:', { labels, durationData });
      
      const durationGraph = new Chart(context, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [
            {
              label: '台数',
              backgroundColor: [
                '#FF6B6B',
                '#4ECDC4',
                '#45B7D1',
                '#96CEB4',
                '#FECA57',
                '#DDA0DD',
                '#98D8C8'
              ],
              data: durationData
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right',
            }
          }
        }
      });
      window.mankuuCharts.push(durationGraph);
    } catch (e) {
      console.error('Error creating duration distribution chart:', e);
    }
  }
})
